import React, { Component } from "react";

class AuthTemplate extends Component {
  render() {
    return <>{this.props.children}</>;
  }
}

export default AuthTemplate;
